var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('list',{ref:"list"},[(_vm.$permission.canWrite())?_c('template',{slot:"toolbar-right"}):_vm._e()],2),_c('edit-dialog',{ref:"editDialog",on:{"close-saved":_vm.reload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }